import React, { useEffect, useState } from "react";
import styledComponents from "styled-components";
import ForgetPasswordComp from "../components/Modules/ForgetPassword";
import { useDispatch } from "react-redux";
import { useGetCoopQuery } from "../store/auth/authApi";
import { setCoopData, setCompanyId } from "../store/auth/index.js";
import { persistThemeFromCoopPayload } from "../theme/companyTheme";

export const ForgetPassword = () => {
  const dispatch = useDispatch();
  const [fullhost, setFullhost] = useState("");

  useEffect(() => {
    let host = window.location.host;
    setFullhost(host);
  }, []);

  // get the company information details
  const { data, isLoading, isSuccess } = useGetCoopQuery(
    { domain_url: fullhost }
  );

  const companyDetails = data?.data;

  useEffect(() => {
    if (isSuccess && data?.data) {
      dispatch(setCoopData(data.data));
      dispatch(setCompanyId(data.data?.company_id));
      persistThemeFromCoopPayload(data.data);
    }
  }, [isSuccess, data, dispatch]);

  return (
    <Style>
      <ForgetPasswordComp isCompanyLoading={isLoading} />
    </Style>
  );
};

const Style = styledComponents.div`
// height:100vh;

.carousel-caption{
  text-align:left;
}
.carousel-indicators{
display:none;
}


h6.background {
  position: relative;
  z-index: 1;
  
  &:before {
      border-top: 1px solid #6B6B6B;
      content:"";
      margin: 0 auto; /* this centers the line to the full width specified */
      position: absolute; /* positioning must be absolute here, and relative positioning must be applied to the parent */
      top: 50%; left: 0; right: 0; bottom: 0;
      width: 95%;
      z-index: -1;
  }

  span { 
      /* to hide the lines from behind the text, you have to set the background color the same as the container */ 
      background: #fff; 
      padding: 0 15px; 
  }
}
@media only screen and (max-width: 991px) {
  .carousel-inner{
    height:50vh;
  }
}
@media only screen and (max-width: 491px) {
  .carousel-inner{
    height:30vh;
  }
  p{
    font-size:14px;
  }
}
`;
